import User from "./Users"
import Goods from "./Goods"

export default function (state = {},action){
    return {
        Users:User(state.Users,action),
        Goods:Goods(state.Users,action)
    }
}